import React from "react";
import Skeleton from "@mui/material/Skeleton";
import Styles from "../Components/ConsumerGenerator/ListingContainer/AvailableListing/AvailableListing.module.css";

const AvailableListingSkeleton = ({ count = 3 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className={`display_flex_column ${Styles.availableListingMainContainer}`}
        >
          <div
            className={`display_flex_row width_95_padding_5 ${Styles.availableListingHeader}`}
          >
            <div className="display_flex_row_gap_8">
              <Skeleton
                variant="text"
                width={180}
                height={24}
                animation="wave"
              />
              <Skeleton
                variant="rounded"
                width={110}
                height={24}
                animation="wave"
              />
            </div>
            <div
              className={`display_flex_row_gap_8 ${Styles.listHeaderExpDate}`}
            >
              <Skeleton
                variant="circular"
                width={16}
                height={16}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width={90}
                height={18}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width={160}
                height={18}
                animation="wave"
              />
            </div>
          </div>

          <div className={`display_flex_row ${Styles.availableListingDetails}`}>
            {[0, 1, 2, 3].map((k) => (
              <div
                key={k}
                className="display_flex_column_gap_4"
                style={{ minWidth: 180 }}
              >
                <Skeleton
                  variant="text"
                  width={120}
                  height={16}
                  animation="wave"
                />
                <Skeleton
                  variant="text"
                  width={150}
                  height={20}
                  animation="wave"
                />
              </div>
            ))}
          </div>

          <div
            className={`width_95_padding_5 display_flex_row ${Styles.availableListingFooter}`}
          >
            <div
              className={`display_flex_row_gap_8 ${Styles.availableListingFooterMain}`}
            >
              <Skeleton
                variant="text"
                width={40}
                height={20}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width={90}
                height={20}
                animation="wave"
              />
            </div>
            <div>
              <Skeleton
                variant="rounded"
                width={120}
                height={36}
                animation="wave"
              />
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default AvailableListingSkeleton;
